module["exports"] = ["Giant panda", "Spectacled bear", "Sun bear", "Sloth bear", "American black bear", "Asian black bear", "Brown bear", "Polar bear"];